<template>
  <div>
    <language-switcher class="col-2" />

    <div class="row form-header">
      <h4 class="kafu-title col-md-10 col-12" v-html="$t('form.uni_title')">
        <!--          {{ $t('kafu.title') }}-->
      </h4>
      <p class="form-description col-md-10 col-12" v-html="$t('form.uni_description')">
        <!--          {{ $t('kafu.description') }}-->
      </p>
    </div>

    <div class="row form-banner">
      <div class="col-12">
        <h1 class="form-title" v-html="$t('form.form_title')">
          <!--            {{ $t('form.title') }}-->
        </h1>
      </div>
      <div class="col-md-3 col-12 form-contacts">
        <h6>{{ $t('form.contacts_title') }}</h6>
        <div v-html="$t('form.contacts_col')"></div>
      </div>
      <div class="col-md-6 col-12 form-contacts" v-html="$t('form.address_col')">
      </div>
      <div class="col-md-3 col-12">
        <img :src="require('@/assets/img/kafu-logo.png')" class="logo" />
      </div>
    </div>
  </div>
</template>
<script>
import form from '@/mixins/form'
import LanguageSwitcher from '@/components/LanguageSwitcher'

export default {
  components: {LanguageSwitcher},
  mixins: [form]
}
</script>